import React, { useState } from 'react'
import { PureQueryOptions } from 'apollo-client'
import { SendAction } from '../actions/send-action'
import { ModifyLibrariesTagsAction } from '../actions/tag-action'
import { ShareByEmailType } from '../../helpers/ui-interfaces'
import { LibraryAgentLanguage } from '../library/library-agent-language'
import { BulkDeleteLibrariesAction } from '../actions/bulk-delete-action'
import {
  BulkDeleteLibrariesModal,
  DeleteLibrariesType
} from '../actions/bulk-delete-modal'
import { Role } from '@contrast-security-inc/base-types'
import { ActionButtonGroup } from '@contrast-security-inc/design-system-actions'
import { css, cx } from '@emotion/css'

export function RowActionsCell({
  organizationID,
  organizationRole,
  library,
  refresh,
  refetchQueries,
  applicationID,
  serverID,
  showDisabled,
  className
}: {
  organizationID: string
  organizationRole: Role
  library: {
    name: string
    hash: string
    tags: string[]
    language: LibraryAgentLanguage
    applications: Array<{ appId: string }>
  }
  refresh: () => Promise<any> | (() => void)
  refetchQueries?: PureQueryOptions[]
  applicationID?: string
  serverID?: string
  showDisabled: boolean
  className?: string
}) {
  const [showDeleteModal, setShowDeleteModal] = useState(false)

  return (
    <ActionButtonGroup
      className={cx(
        css`
          justify-content: flex-start;
        `,
        className
      )}
    >
      <ModifyLibrariesTagsAction
        libraries={[library]}
        applicationRole={organizationRole}
        organizationID={organizationID}
        refetchQueries={refetchQueries}
        refresh={refresh}
      />
      <SendAction
        showDisabled={showDisabled}
        role={organizationRole}
        libraries={[library]}
        organizationID={organizationID}
        refetchQueries={refetchQueries}
        refresh={refresh}
        shareType={ShareByEmailType.BY_HASHES}
      />
      <BulkDeleteLibrariesAction
        libraries={[library]}
        showDisabled={showDisabled}
        organizationRole={organizationRole}
        setShowDeleteModal={setShowDeleteModal}
      />
      {showDeleteModal && (
        <BulkDeleteLibrariesModal
          deleteType={DeleteLibrariesType.BY_HASHES}
          organizationID={organizationID}
          libraries={[library]}
          onSuccess={refresh}
          refetchQueries={refetchQueries}
          showDisabled={showDisabled}
          organizationRole={organizationRole}
          applicationID={applicationID}
          serverID={serverID}
          setShowDeleteModal={setShowDeleteModal}
        />
      )}
    </ActionButtonGroup>
  )
}
